import {AdDataValueObject} from './AdDataValueObject.js'
import {CalculatorPluginTransactionsValueObject} from './CalculatorPluginTransactionsValueObject.js'
import {LoanCalculationsTransactionsValueObject} from './LoanCalculationsTransactionsValueObject.js'

export class TransactionsValueObjectsFactory {
  static adDataValueObject = ({id, make, model, photo, price, sellerName}) =>
    new AdDataValueObject({id, make, model, photo, price, sellerName})

  static calculatorPluginTransactionsValueObject = ({url, widgetType}) =>
    new CalculatorPluginTransactionsValueObject({url, widgetType})

  static loanCalculationsTransactionsValueObject = ({
    minEntry,
    maxEntry,
    availableTerms,
    fee,
    capital,
    openingExpenses,
    isOpeningExpensesFinanced,
    tin,
    tae,
    totalAmountDue,
    totalLoanAmount,
    openingPercentage,
    totalInterest,
    totalLoanCost
  }) =>
    new LoanCalculationsTransactionsValueObject({
      minEntry,
      maxEntry,
      availableTerms,
      fee,
      capital,
      openingExpenses,
      isOpeningExpensesFinanced,
      tin,
      tae,
      totalAmountDue,
      totalLoanAmount,
      openingPercentage,
      totalInterest,
      totalLoanCost
    })
}
